(function () {
  'use strict';

  angular.module('app').component('accountsMaintenance', accountsMaintenance());

  function accountsMaintenance() {
    return {
      bindings: {},
      controller: AccountsMaintenanceComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/admin/system-maintenance/components/accounts-maintenance/accounts-maintenance.component.html',
    };
  }

  AccountsMaintenanceComponent.$inject = [
    'UtilService',
    'AbilityService',
    'SystemMaintenanceService',
  ];

  function AccountsMaintenanceComponent(UtilService, AbilityService, SystemMaintenanceService) {
    var vm = this;

    vm.permissions = {
      canUpdateCountriesForMasterAccount: AbilityService.can(
        'update_countries_for_master_account_systemmaintenance_superadmin'
      ),
      canUpdateCountriesForAllAccounts: AbilityService.can(
        'update_countries_for_all_accounts_systemmaintenance_superadmin'
      ),
      canUpdateAccountSettingsForAllAccounts: AbilityService.can(
        'update_account_settings_for_all_accounts_systemmaintenance_superadmin'
      ),
      canUpdateRolesActionsForAllAccounts: AbilityService.can(
        'update_roles_actions_for_all_accounts_systemmaintenance_superadmin'
      ),
    };

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.updateCountriesForMasterAccount = updateCountriesForMasterAccount;
    vm.updateCountriesForAllAccounts = updateCountriesForAllAccounts;
    vm.updateAccountSettingsForAllAccounts = updateAccountSettingsForAllAccounts;
    vm.updateRolesActionsForAllAccounts = updateRolesActionsForAllAccounts;

    function updateCountriesForMasterAccount() {
      if (!vm.permissions.canUpdateCountriesForMasterAccount) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateCountriesForMasterAccount');
      // };

      SystemMaintenanceService.updateCountriesForMasterAccount({});
    }

    function updateCountriesForAllAccounts() {
      if (!vm.permissions.canUpdateCountriesForAllAccounts) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateCountriesForAllAccounts');
      // };

      SystemMaintenanceService.updateCountriesForAllAccounts({});
    }

    function updateAccountSettingsForAllAccounts() {
      if (!vm.permissions.canUpdateAccountSettingsForAllAccounts) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateAccountSettingsForAllAccounts');
      // };

      SystemMaintenanceService.updateAccountSettingsForAllAccounts({});
    }

    function updateRolesActionsForAllAccounts() {
      if (!vm.permissions.canUpdateRolesActionsForAllAccounts) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateRolesActionsForAllAccounts');
      // };

      SystemMaintenanceService.updateRolesActionsForAllAccounts({});
    }
  }
})();
